import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=fa73c6a8&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=ts"
export * from "./Tree.vue?vue&type=script&lang=ts"
import style0 from "./Tree.vue?vue&type=style&index=0&id=fa73c6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa73c6a8",
  null
  
)

export default component.exports